import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=4a8d41c5"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=4a8d41c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports